 
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import React from 'react';
import CustomPagination from '../CustomPagination';

export default function PaginatedControls({
  pagination,
  setPagination,
  packagesLength,
  searchValue,
  filters,
  handleSearch,
  fetchAll,
  isSearchActive
}) {
  // Pages with sort/date filters pass isSearchActive: without it, a sort or
  // date filter alone fell through to fetchAll and page 2 lost the sort.
  const searchActive = isSearchActive ?? (!!searchValue || filters.length > 0);

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value, 10);
    setPagination((prev) => ({
      ...prev,
      limit: newLimit,
      currentPage: 1
    }));

    if (searchActive) {
      handleSearch(1, newLimit);
    } else {
      fetchAll(1, newLimit);
    }
  };

  const handlePageChange = (e, page) => {
    setPagination((prev) => ({ ...prev, currentPage: page }));
    if (searchActive) {
      handleSearch(page, pagination.limit);
    } else {
      fetchAll(page, pagination.limit);
    }
  };

  return (
    <Box
      mb={2}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      {/* Left: "Show up to" Dropdown */}
      <FormControl
        size="small"
        variant="outlined"
        style={{ marginTop: 8, minWidth: 160 }}
      >
        <InputLabel id="limit-select-label">Show up to</InputLabel>
        <Select
          labelId="limit-select-label"
          value={pagination.limit}
          label="Show up to"
          onChange={handleLimitChange}
        >
          {[5, 10, 20, 50].map((value) => (
            <MenuItem key={value} value={value}>
              {value} items
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Right: Pagination and Total Items */}
      <Box display="flex" alignItems="center" gap={2}>
        <Typography variant="body2" color="textSecondary">
          {packagesLength > 0 && (
            <>
              {((pagination.currentPage || 1) - 1) * pagination.limit + 1} -{' '}
              {Math.min(
                (pagination.currentPage || 1) * pagination.limit,
                pagination.total || 0
              )}{' '}
              of {pagination.total || 0} items
            </>
          )}
        </Typography>

        <CustomPagination
          count={pagination.totalPages}
          page={pagination.currentPage}
          onChange={handlePageChange}
        />
      </Box>
    </Box>
  );
}
